export { default } from './CampaignCardv2'
